import { SUBSCRIPTION_STATUS_STATE } from './constants'

export const getError = state => state[SUBSCRIPTION_STATUS_STATE]?.error
export const getIsFetching = state => state[SUBSCRIPTION_STATUS_STATE]?.isFetching
export const getSubscriptionStatus = state => state[SUBSCRIPTION_STATUS_STATE]?.status
export const getSubscriptions = state => state[SUBSCRIPTION_STATUS_STATE]?.subscriptions
